import { defineMessages, IntlFormatters } from "react-intl";
import { RhythmSyllableType, SolfaAudioType } from "../../front/store/user/models";

const rhytnameOptionsMessages = defineMessages({
    ririTamTi: {
        id: "rhytnameOptions.ririTamTi",
    },
    tiriTamTi: {
        id: "rhytnameOptions.tiriTamTi",
    },
    teteTamTi: {
        id: "rhytnameOptions.teteTamTi",
    },
    tiriTaiTi: {
        id: "rhytnameOptions.tiriTaiTi",
    },
    ririTaiTi: {
        id: "rhytnameOptions.ririTaiTi",
    },
    taKaDiMi: {
        id: "rhytnameOptions.taKaDiMi",
    },
    gordon: {
        id: "rhytnameOptions.gordon",
    },
    taKaTiKi: {
        id: "rhytnameOptions.taKaTiKi",
    },
    french: {
        id: "rhytnameOptions.french",
    },
    aussie: {
        id: "rhytnameOptions.aussie",
    }
});

export const rhytnameOptions = (fm: IntlFormatters["formatMessage"]) => [
    {
        label: fm(rhytnameOptionsMessages.ririTamTi),
        value: RhythmSyllableType.Kodaly,
    },
    {
        label: fm(rhytnameOptionsMessages.tiriTamTi),
        value: RhythmSyllableType.KodalyTiRi,
    },
    {
        label: fm(rhytnameOptionsMessages.tiriTaiTi),
        value: RhythmSyllableType.KodalyTiRiTaiTi,
    },
    {
        label: fm(rhytnameOptionsMessages.ririTaiTi),
        value: RhythmSyllableType.KodalyRiRiTaiTi,
    },
    {
        label: fm(rhytnameOptionsMessages.teteTamTi),
        value: RhythmSyllableType.KodalyTeTe,
    },
    {
        label: fm(rhytnameOptionsMessages.aussie),
        value: RhythmSyllableType.Aussie,
    },
    {
        label: fm(rhytnameOptionsMessages.taKaDiMi),
        value: RhythmSyllableType.Takadimi,
    },
    {
        label: fm(rhytnameOptionsMessages.gordon),
        value: RhythmSyllableType.Gordon,
    },
    {
        label: fm(rhytnameOptionsMessages.taKaTiKi),
        value: RhythmSyllableType.Takatiki,
    },
    {
        label: fm(rhytnameOptionsMessages.french),
        value: RhythmSyllableType.French,
    },
];

const solfaAudioOptionsMessages = defineMessages({
    solfa: {
        id: "solfaAudio.solfa",
    },
    lala: {
        id: "solfaAudio.lala",
    },
    piano: {
        id: "solfaAudio.piano",
    },
})

export const solfaAudioOptions = (fm: IntlFormatters["formatMessage"]) => [
    {
        label: fm(solfaAudioOptionsMessages.solfa),
        value: SolfaAudioType.Solfa,
    },
    {
        label: fm(solfaAudioOptionsMessages.lala),
        value: SolfaAudioType.Lala,
    },
    {
        label: fm(solfaAudioOptionsMessages.piano),
        value: SolfaAudioType.Piano,
    },
]

const rhytPlayStyleOptionsMessages = defineMessages({
    auto: {
        id: "rhytPlayStyleOptions.auto",
    },
    slap: {
        id: "rhytPlayStyleOptions.slap",
    },
    piano: {
        id: "rhytPlayStyleOptions.piano",
    },
});

export const rhytPlayStyleOptions = (fm: IntlFormatters["formatMessage"]) => [
    {
        label: fm(rhytPlayStyleOptionsMessages.auto),
        value: "auto",
    },
    {
        label: fm(rhytPlayStyleOptionsMessages.slap),
        value: "slap",
    },
    {
        label: fm(rhytPlayStyleOptionsMessages.piano),
        value: "piano",
    },
];


const rhytPatternMessages = defineMessages({
    ta_ta: {
        id: "rhytPatterns.ta_ta",
    },
    titi: {
        id: "rhytPatterns.titi",
    },
    tam_ti: {
        id: "rhytPatterns.tam_ti",
    },
    ti_tam: {
        id: "rhytPatterns.ti_tam",
    },
    "ta-a": {
        id: "rhytPatterns.ta-a",
    },
    "ta-a-a": {
        id: "rhytPatterns.ta-a-a",
    },
    "ta-a-a-a": {
        id: "rhytPatterns.ta-a-a-a",
    },
    synkope: {
        id: "rhytPatterns.synkope",
    },
    timri: {
        id: "rhytPatterns.timri",
    },
    ritim: {
        id: "rhytPatterns.ritim",
    },
    tiriri: {
        id: "rhytPatterns.tiriri",
    },
    ririti: {
        id: "rhytPatterns.ririti",
    },
    riririri: {
        id: "rhytPatterns.riririri",
    },
    rest4: {
        id: "rhytPatterns.rest-4",
    },
    rest8: {
        id: "rhytPatterns.rest-8",
    },
    rest16: {
        id: "rhytPatterns.rest-16",
    },
    truplet: {
        id: "rhytPatterns.truplet",
    },
    tie: {
        id: "rhytPatterns.tie",
    },
});

export const rhytPatterns = (fm: IntlFormatters["formatMessage"]): { [prop: string]: string } => ({
    "ta ta": fm(rhytPatternMessages.ta_ta),
    titi: fm(rhytPatternMessages.titi),
    "tam ti": fm(rhytPatternMessages.tam_ti),
    "ti tam": fm(rhytPatternMessages.ti_tam),
    "ta-a": fm(rhytPatternMessages["ta-a"]),
    "ta-a-a": fm(rhytPatternMessages["ta-a-a"]),
    "ta-a-a-a": fm(rhytPatternMessages["ta-a-a-a"]),
    synkope: fm(rhytPatternMessages.synkope),
    timri: fm(rhytPatternMessages.timri),
    ritim: fm(rhytPatternMessages.ritim),
    tiriri: fm(rhytPatternMessages.tiriri),
    ririti: fm(rhytPatternMessages.ririti),
    riririri: fm(rhytPatternMessages.riririri),
    "rest-4": fm(rhytPatternMessages.rest4),
    "rest-8": fm(rhytPatternMessages.rest8),
    "rest-16": fm(rhytPatternMessages.rest16),
    truplet: fm(rhytPatternMessages.truplet),
    tie: fm(rhytPatternMessages.tie),
});

const isJa = (locale: string) => locale === "ja" || locale === "ja-jp";

// Token → katakana (hosszabbakat előre!)
const RHYT_JA_MAP: Array<[RegExp, string]> = [
    // gyakori összetettek
    [/\btiri\b/gi, "ティリ"],
    [/\btam\b/gi, "タム"],
    [/\btete\b/gi, "テテ"],
    [/\btiti\b/gi, "ティティ"],
    [/\btiki\b/gi, "ティキ"],
    [/\btaka\b/gi, "タカ"],
    [/\btakatiki\b/gi, "タカティキ"],
    [/\btakadimi\b/gi, "タカディミ"],
    
    // alap szótagok (Takadimi/Takatiki/Kodály variánsok)
    [/\bta\b/gi, "タ"],
    [/\bti\b/gi, "ティ"],
    [/\btu\b/gi, "トゥ"],
    [/\bte\b/gi, "テ"],
    [/\bdi\b/gi, "ディ"],
    [/\bda\b/gi, "ダ"],
    [/\bka\b/gi, "カ"],
    [/\bki\b/gi, "キ"],
    [/\bmi\b/gi, "ミ"],
    [/\bri\b/gi, "リ"],
    [/\bru\b/gi, "ル"],
    [/\blu\b/gi, "ル"],
    [/\bdu\b/gi, "ドゥ"],
    [/\bde\b/gi, "デ"],
    [/\bfa\b/gi, "ファ"],
    [/\bfe\b/gi, "フェ"],
    [/\bfi\b/gi, "フィ"],
    [/\ku\b/gi, "ク"],
    [/\ke\b/gi, "ケ"],

    // hosszjelölés (pl. ta-a / ta-a-a)
    [/taaaa/gi, "タアアア"],
    [/taaa/gi, "タアア"],
    [/taa/gi, "タア"],
    [/a/gi, "ア"],
    [/\btoo\b/gi, "トゥー"],
    [/\btoom\b/gi, "トゥーム"],
    [/\bfour\b/gi, "フォー"],
    [/\bm\b/gi, "ム"],

];

export const i18nRhythmName = (input: string, locale: string) => {
    if (!input) return input;
    if (!isJa(locale)) return input;

    // elválasztók megtartása (szóköz, kötőjel, pont, stb.)
    let out = input;

    // előbb a hosszjelölések/összetettek, aztán az alapok
    for (const [re, rep] of RHYT_JA_MAP) out = out.replace(re, rep);

    // opcionális: szóközök helyett japán középpont, ha neked tetszik
    // out = out.replace(/\s+/g, "・");

    return out;
};